var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isDataAvailable === true
        ? [
            _c("expiry-popup", {
              attrs: {
                projectExpirationList: _vm.projectExpirationList,
                serviceExpirationList: _vm.serviceExpirationList,
                expiryAddOnList: _vm.expiryAddOnList,
                roleId: _vm.roleId,
                account_id: _vm.account_id,
                userId: _vm.userId,
              },
            }),
          ]
        : _vm._e(),
      _vm.displayDashboard == "default"
        ? [
            _c("default-dashboard", {
              attrs: {
                isDashboardNotification: _vm.isDashboardNotification,
                isDashboardCustomizable: _vm.isDashboardCustomizable,
                roleId: _vm.roleId,
                account_id: _vm.account_id,
                userId: _vm.userId,
                isDefault: _vm.isDefault,
              },
            }),
          ]
        : _vm._e(),
      _vm.displayDashboard === "customized"
        ? [_c("customized-dashboard", { attrs: { isDefault: _vm.isDefault } })]
        : _vm._e(),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }